<template>
  <div class="footer-301">
    <b-container>
      <b-row align-h="center" class=" py-5">
        <b-col lg="3">
          <MainFooterMenu/>
        </b-col>
        <b-col lg="3">
          <b-row class="text-center">
            <b-col lg="12" class="mt-3" v-if="findAttributeOnSiteInfo('tel_phone')">
              <b-icon-telephone-fill class="text-white  d-inline-block"/>

              <a class="text-decoration-none  text-white d-block font-size-custom" dir="ltr"
                 v-for="(tel_phone ,index) in findAttributeOnSiteInfo('tel_phone')" :key="index"
                 :href="`tel:${tel_phone}`"> {{ tel_phone }}</a>

              <a class="text-decoration-none  text-white d-block font-size-custom" dir="ltr"
                 v-for="(cell_phone ,index) in findAttributeOnSiteInfo('cell_phone')" :key="index"
                 :href="`tel:${cell_phone}`"> {{ cell_phone }}</a>

            </b-col>

            <b-col lg="12" class="mt-3" v-if="findAttributeOnSiteInfo('email')">
              <b-icon-pin-map-fill class="text-white  d-inline-block"/>

              <a class="text-decoration-none  text-white d-block font-size-custom" dir="ltr"
                 v-for="(address ,index) in findAttributeOnSiteInfo('address')" :key="index"
                 href="javascript:void(0)"> {{ address }}</a>
            </b-col>

            <b-col lg="12" class="mt-3" v-if="findAttributeOnSiteInfo('fax')">
              <b-icon-printer-fill class="text-white  d-inline-block"/>

              <a class="text-decoration-none  text-white d-block font-size-custom" dir="ltr"
                 v-for="(fax ,index) in findAttributeOnSiteInfo('fax')" :key="index"
                 href="javascript:void(0)"> {{ fax }}</a>

            </b-col>

            <b-col lg="12" class="mt-3" v-if="findAttributeOnSiteInfo('email')">
              <b-icon-envelope-fill class="text-white  d-inline-block"/>

              <a class="text-decoration-none  text-white d-block font-size-custom" dir="ltr"
                 v-for="(email ,index) in findAttributeOnSiteInfo('email')" :key="index"
                 :href="`mailto:${email}`"> {{ email }}</a>
            </b-col>
          </b-row>


        </b-col>
        <b-col lg="3">
          <b-col lg="12" class="text-center">
            <img class="col-lg-12 footer-301-logo" :src="findAttributeOnSiteInfo('icon')[0]"
                 :alt="findAttributeOnSiteInfo('site_name')[0]">
            <p class=" text-white my-4" v-if="findAttributeOnSiteInfo('site_name')">
              {{ findAttributeOnSiteInfo('site_name')[0] }}</p>
            <p class=" text-white my-4" v-if="findAttributeOnSiteInfo('slogan')">
              {{ findAttributeOnSiteInfo('slogan')[0] }}
            </p>
          </b-col>

          <b-row>


            <m-a v-for="instagram in findAttributeOnSiteInfo('social_media_instagram')"
                 :key="instagram"
                 :href="`${instagram}`">
              <div class="footer-301-social-logo">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 551.034 551.034" style="enable-background:new 0 0 551.034 551.034;"
                     xml:space="preserve">
<g id="XMLID_13_">

		<linearGradient id="XMLID_2_" gradientUnits="userSpaceOnUse" x1="275.517" y1="4.5714" x2="275.517" y2="549.7202"
                    gradientTransform="matrix(1 0 0 -1 0 554)">
		<stop offset="0" style="stop-color:#E09B3D"/>
      <stop offset="0.3" style="stop-color:#C74C4D"/>
      <stop offset="0.6" style="stop-color:#C21975"/>
      <stop offset="1" style="stop-color:#7024C4"/>
	</linearGradient>
  <path id="XMLID_17_" style="fill:url(#XMLID_2_);" d="M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722
		c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156
		C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156
		c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722
		c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"/>

  <linearGradient id="XMLID_3_" gradientUnits="userSpaceOnUse" x1="275.517" y1="4.5714" x2="275.517" y2="549.7202"
                  gradientTransform="matrix(1 0 0 -1 0 554)">
		<stop offset="0" style="stop-color:#E09B3D"/>
    <stop offset="0.3" style="stop-color:#C74C4D"/>
    <stop offset="0.6" style="stop-color:#C21975"/>
    <stop offset="1" style="stop-color:#7024C4"/>
	</linearGradient>
  <path id="XMLID_81_" style="fill:url(#XMLID_3_);" d="M275.517,133C196.933,133,133,196.933,133,275.516
		s63.933,142.517,142.517,142.517S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6
		c-48.095,0-87.083-38.988-87.083-87.083s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083
		C362.6,323.611,323.611,362.6,275.517,362.6z"/>

  <linearGradient id="XMLID_4_" gradientUnits="userSpaceOnUse" x1="418.306" y1="4.5714" x2="418.306" y2="549.7202"
                  gradientTransform="matrix(1 0 0 -1 0 554)">
		<stop offset="0" style="stop-color:#E09B3D"/>
    <stop offset="0.3" style="stop-color:#C74C4D"/>
    <stop offset="0.6" style="stop-color:#C21975"/>
    <stop offset="1" style="stop-color:#7024C4"/>
	</linearGradient>
  <circle id="XMLID_83_" style="fill:url(#XMLID_4_);" cx="418.306" cy="134.072" r="34.149"/>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
</svg>
              </div>
            </m-a>

            <m-a v-for="whatsapp in findAttributeOnSiteInfo('social_media_whatsapp')"
                 :key="whatsapp"
                 :href="`https://wa.me/${whatsapp}`">
              <div class="footer-301-social-logo">
                <svg width="100%" height="100%" viewBox="-2.73 0 1225.016 1225.016" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink">
                  <path fill="#E0E0E0"
                        d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"/>
                  <linearGradient id="a" gradientUnits="userSpaceOnUse" x1="609.77" y1="1190.114" x2="609.77"
                                  y2="21.084">
                    <stop offset="0" stop-color="#20b038"/>
                    <stop offset="1" stop-color="#60d66a"/>
                  </linearGradient>
                  <path fill="url(#a)"
                        d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"/>
                  <image overflow="visible" opacity=".08" width="682" height="639" xlink:href="FCC0802E2AF8A915.png"
                         transform="translate(270.984 291.372)"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFF"
                        d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z"/>
                  <path fill="#FFF"
                        d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"/>
                </svg>
              </div>
            </m-a>

            <m-a v-for="twitter in findAttributeOnSiteInfo('social_media_twitter')"
                 :key="twitter"
                 :href="twitter">
              <div class="footer-301-social-logo">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 410.155 410.155" style="enable-background:new 0 0 410.155 410.155;"
                     xml:space="preserve">
<path style="fill:#76A9EA;" d="M403.632,74.18c-9.113,4.041-18.573,7.229-28.28,9.537c10.696-10.164,18.738-22.877,23.275-37.067
	l0,0c1.295-4.051-3.105-7.554-6.763-5.385l0,0c-13.504,8.01-28.05,14.019-43.235,17.862c-0.881,0.223-1.79,0.336-2.702,0.336
	c-2.766,0-5.455-1.027-7.57-2.891c-16.156-14.239-36.935-22.081-58.508-22.081c-9.335,0-18.76,1.455-28.014,4.325
	c-28.672,8.893-50.795,32.544-57.736,61.724c-2.604,10.945-3.309,21.9-2.097,32.56c0.139,1.225-0.44,2.08-0.797,2.481
	c-0.627,0.703-1.516,1.106-2.439,1.106c-0.103,0-0.209-0.005-0.314-0.015c-62.762-5.831-119.358-36.068-159.363-85.14l0,0
	c-2.04-2.503-5.952-2.196-7.578,0.593l0,0C13.677,65.565,9.537,80.937,9.537,96.579c0,23.972,9.631,46.563,26.36,63.032
	c-7.035-1.668-13.844-4.295-20.169-7.808l0,0c-3.06-1.7-6.825,0.485-6.868,3.985l0,0c-0.438,35.612,20.412,67.3,51.646,81.569
	c-0.629,0.015-1.258,0.022-1.888,0.022c-4.951,0-9.964-0.478-14.898-1.421l0,0c-3.446-0.658-6.341,2.611-5.271,5.952l0,0
	c10.138,31.651,37.39,54.981,70.002,60.278c-27.066,18.169-58.585,27.753-91.39,27.753l-10.227-0.006
	c-3.151,0-5.816,2.054-6.619,5.106c-0.791,3.006,0.666,6.177,3.353,7.74c36.966,21.513,79.131,32.883,121.955,32.883
	c37.485,0,72.549-7.439,104.219-22.109c29.033-13.449,54.689-32.674,76.255-57.141c20.09-22.792,35.8-49.103,46.692-78.201
	c10.383-27.737,15.871-57.333,15.871-85.589v-1.346c-0.001-4.537,2.051-8.806,5.631-11.712c13.585-11.03,25.415-24.014,35.16-38.591
	l0,0C411.924,77.126,407.866,72.302,403.632,74.18L403.632,74.18z"/>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
</svg>

              </div>
            </m-a>

            <m-a v-for="telegram in findAttributeOnSiteInfo('social_media_telegram')"
                 :key="telegram"
                 :href="telegram">
              <div class="footer-301-social-logo">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="100%" height="100%">
                  <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"/>
                  <path fill="#fff"
                        d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"/>
                  <path fill="#b0bec5"
                        d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"/>
                  <path fill="#cfd8dc"
                        d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"/>
                </svg>
              </div>
            </m-a>

            <m-a v-for="linkedin in findAttributeOnSiteInfo('social_media_linkedin')"
                 :key="linkedin"
                 :href="linkedin">
              <div class="footer-301-social-logo">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 382 382" style="enable-background:new 0 0 382 382;" xml:space="preserve">
<path style="fill:#0077B7;" d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
	C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
	H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
	c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
	s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
	c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
	c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
	c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
	L341.91,330.654L341.91,330.654z"/>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
</svg>
              </div>
            </m-a>

            <m-a v-for="youtube in findAttributeOnSiteInfo('social_media_youtube')"
                 :key="youtube"
                 :href="youtube">
              <div class="footer-301-social-logo">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 461.001 461.001" style="enable-background:new 0 0 461.001 461.001;"
                     xml:space="preserve">
<g>
	<path style="fill:#F61C0D;" d="M365.257,67.393H95.744C42.866,67.393,0,110.259,0,163.137v134.728
		c0,52.878,42.866,95.744,95.744,95.744h269.513c52.878,0,95.744-42.866,95.744-95.744V163.137
		C461.001,110.259,418.135,67.393,365.257,67.393z M300.506,237.056l-126.06,60.123c-3.359,1.602-7.239-0.847-7.239-4.568V168.607
		c0-3.774,3.982-6.22,7.348-4.514l126.06,63.881C304.363,229.873,304.298,235.248,300.506,237.056z"/>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
</svg>
              </div>
            </m-a>

            <m-a v-for="pinterest in findAttributeOnSiteInfo('social_media_pinterest')"
                 :key="pinterest"
                 :href="pinterest">
              <div class="footer-301-social-logo">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 112.198 112.198" style="enable-background:new 0 0 112.198 112.198;"
                     xml:space="preserve">
<g>
	<circle style="fill:#CB2027;" cx="56.099" cy="56.1" r="56.098"/>
  <g>
		<path style="fill:#F1F2F2;" d="M60.627,75.122c-4.241-0.328-6.023-2.431-9.349-4.45c-1.828,9.591-4.062,18.785-10.679,23.588
			c-2.045-14.496,2.998-25.384,5.34-36.941c-3.992-6.72,0.48-20.246,8.9-16.913c10.363,4.098-8.972,24.987,4.008,27.596
			c13.551,2.724,19.083-23.513,10.679-32.047c-12.142-12.321-35.343-0.28-32.49,17.358c0.695,4.312,5.151,5.621,1.78,11.571
			c-7.771-1.721-10.089-7.85-9.791-16.021c0.481-13.375,12.018-22.74,23.59-24.036c14.635-1.638,28.371,5.374,30.267,19.14
			C85.015,59.504,76.275,76.33,60.627,75.122L60.627,75.122z"/>
	</g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
                  <g>
</g>
</svg>
              </div>
            </m-a>

            <m-a v-for="aparat in findAttributeOnSiteInfo('social_media_aparat')"
                 :key="aparat"
                 :href="aparat">
              <div class="footer-301-social-logo">
                <svg style="transform: scale(1.5)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="100%"
                     height="100%">
                  <path fill="#263238"
                        d="M21.881 6.136l-4.315-.974c-3.52-.795-7.017 1.414-7.812 4.934l-.983 4.351C11.603 9.95 16.357 6.788 21.881 6.136zM6.136 26.119l-.974 4.315c-.795 3.52 1.414 7.017 4.934 7.812l4.351.983C9.95 36.396 6.788 31.643 6.136 26.119zM37.904 9.754l-4.351-.983c4.497 2.832 7.659 7.586 8.311 13.109l.974-4.315C43.633 14.047 41.424 10.549 37.904 9.754zM26.119 41.864l4.315.974c3.52.795 7.017-1.414 7.812-4.934l.983-4.351C36.397 38.05 31.643 41.212 26.119 41.864z"/>
                  <path fill="#e91e63"
                        d="M24,8C15.163,8,8,15.163,8,24s7.163,16,16,16s16-7.163,16-16S32.837,8,24,8z M20,13 c2.209,0,4,1.791,4,4c0,2.209-1.791,4-4,4s-4-1.791-4-4C16,14.791,17.791,13,20,13z M17,32c-2.209,0-4-1.791-4-4 c0-2.209,1.791-4,4-4s4,1.791,4,4C21,30.209,19.209,32,17,32z M22,24c0-1.105,0.895-2,2-2s2,0.895,2,2c0,1.105-0.895,2-2,2 S22,25.105,22,24z M28,35c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C32,33.209,30.209,35,28,35z M31,24 c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C35,22.209,33.209,24,31,24z"/>
                </svg>
              </div>
            </m-a>

            <m-a v-for="tamasha in findAttributeOnSiteInfo('social_media_tamasha')"
                 :key="tamasha"
                 :href="tamasha">
              <div class="footer-301-social-logo">
                <svg style="transform: scale(1.4)" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" height="100%"
                     viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">  <image id="image0"
                                                                                                         width="64"
                                                                                                         height="64"
                                                                                                         x="0" y="0"
                                                                                                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAANlBMVEX////xHSHxHSHxHSHx
HSHxHSHxHSHxHSHxHSHxHSHxHSHxHSHxHSHxHSHxHSHxHSHxHSH///+7Sfw/AAAAEHRSTlMAEIDw
wCBg4JAwoNBAsFBwXbEx6AAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElN
RQfmChITNR76Nzd2AAABWElEQVRYw+1W2ZaDIAwti1IRav7/a2fomVgWIQl9HO8baq5JuFkejxs3
OlDaANhl2n518MZTTZlvFhBmnfDeQ449CO1T8CWiJBUvBy2MZqdigWs4bhwRegxMgp49mG8JuLfZ
MedLcpxBdWi9iQnMgS9XQ6u7tff4fbANI4PAosdLru+BKqrgXxh8re9uVksB49MLfTuawONPsuLO
oAkCe4YZOtIYErhMeHqCoKjeVUSQslX3j7bDDAi2GE/d6vh3i1WPGxJknqf/oi9WTBD291dhkmDB
xhTKI5NAfS4ulEcewZrpVpdHDkEow3UWQESgDDDRIfBce7KYKDDKeYjIaSh97NyWdo3hysDJnrCt
17dHzCgq9+SUHwd/UOZjAtbG1lei3Rjmv6XfqYVzRpEI10sW1zzhaJzwwnVVPcvgpYtmysSnjbiJ
VTcB5zF/w2yQ5pFox73x3/EDIuZN9/ZnIE4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTAtMThU
MTc6NTM6MzArMDI6MDDthP8/AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTEwLTE4VDE3OjUzOjMw
KzAyOjAwnNlHgwAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAAASUVORK5C
YII="/>
</svg>
              </div>
            </m-a>

            <m-a v-for="namasha in findAttributeOnSiteInfo('social_media_namasha')"
                 :key="namasha"
                 :href="namasha">
              <div class="footer-301-social-logo">
                <svg style="transform: scale(1.5)" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" height="100%"
                     viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">  <image id="image0"
                                                                                                         width="64"
                                                                                                         height="64"
                                                                                                         x="0" y="0"
                                                                                                         href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAACBjSFJN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"/></svg>

              </div>
            </m-a>


          </b-row>


        </b-col>
        <b-col lg="3" class="text-center mt-5">
          <div class=" bg-white p-5 symbol-image rounded rounded-9 d-inline  mb-4"
               v-if="findAttributeOnSiteInfo('symbol')"
               v-for="symbol in findAttributeOnSiteInfo('symbol')" v-html="symbol"></div>
        </b-col>
      </b-row>
      <b-container class="footer-301-sign text-center py-2 rounded-top">
        <b-row>
          <b-col lg="6">
             <span class="text-white">
                طراحی و توسعه توسط
              <a target="_blank" class="text-white text-decoration-none" href="https://mixitweb.com">Mixitweb.com</a>
             </span>
          </b-col>
          <b-col lg="6">
            <p class="text-white"> {{ findAttributeOnSiteInfo('copy_right')[0] }}</p>
          </b-col>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import MainFooterMenu from './MainFooterMenu'

export default {
  name: "F301",
  components: {MainFooterMenu},
}
</script>

<style>
.symbol-image img {
  height: 45%;
}
</style>

<style scoped>
.footer-301 {
  background: #191a1c;
}

.footer-301-logo {
  width: 90px;
}

.footer-301-sign {
  background: #151618;
}

.footer-301-social-logo {
  width: 40px;
  height: 40px;
  margin: 8px;
}

</style>